/* LB product gallery grid is handled 100% by CSS (no JS override). */

// Fix newsletter form width on mobile/tablet
function fixNewsletterWidth() {
  if (window.innerWidth <= 989) {
    // Target the newsletter form container
    const newsletterBlock = document.querySelector('.footer-block__newsletter');
    if (newsletterBlock) {
      newsletterBlock.style.width = '75%';
      newsletterBlock.style.maxWidth = '75%';
      newsletterBlock.style.margin = '0 auto';
    }
  }
}

// Run on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', fixNewsletterWidth);
} else {
  fixNewsletterWidth();
}

// Run on window resize
window.addEventListener('resize', fixNewsletterWidth);

// Fix GET EARLY ACCESS heading size
function fixEarlyAccessHeading() {
  const heading = document.querySelector('.footer-block__heading.inline-richtext');
  if (heading && heading.textContent.includes('GET EARLY ACCESS')) {
    heading.style.fontSize = '24px'; // Change this to whatever size you want
  }
}

// Run on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', fixEarlyAccessHeading);
} else {
  fixEarlyAccessHeading();
}

// Adjust footer copyright height for tablet screens (768px - 1024px)
function adjustCopyrightHeight() {
  const copyrightSection = document.querySelector('.footer__content-bottom-wrapper');
  
  if (!copyrightSection) return;
  
  const width = window.innerWidth;
  
  if (width >= 768 && width <= 1024) {
    copyrightSection.style.height = '135px'; // Change this to your desired height
    copyrightSection.style.minHeight = '135px';
  } else {
    copyrightSection.style.height = '';
    copyrightSection.style.minHeight = '';
  }
}

document.addEventListener('DOMContentLoaded', adjustCopyrightHeight);

let resizeTimer;
window.addEventListener('resize', function() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(adjustCopyrightHeight, 250);
});


    // Watch for grid changes
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' && 
            (mutation.target.closest('media-gallery') || 
             mutation.target.classList?.contains('lb-media-grid'))) {
          setTimeout(triggerCSSRefresh, 100);
        }
      });
    });
    
    // Observe the product form area
    const productForm = document.querySelector('.product-form__buttons');
    if (productForm) {
      observer.observe(productForm, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    }

// Sidebar Recommendations - Load custom product recommendations
(function() {
  function loadSidebarRecommendations() {
    const container = document.querySelector('.sidebar-recommendations-section');
    if (!container) {
      console.log('[SR] Container not found, skipping recommendations');
      return;
    }
    
    const placeholder = container.querySelector('.sidebar-recommendations-placeholder');
    if (!placeholder) {
      console.log('[SR] Placeholder not found, skipping recommendations');
      return;
    }
    
    // Extract product ID from nearest element with data-product-id
    let productId = container.closest('[data-product-id]')?.getAttribute('data-product-id');
    
    // Fallback: search up the DOM tree
    if (!productId) {
      let parent = container.parentElement;
      while (parent && !productId) {
        productId = parent.getAttribute('data-product-id');
        parent = parent.parentElement;
      }
    }
    
    // Another fallback: check for product-info element
    if (!productId) {
      const productInfo = document.querySelector('[data-product-id]');
      productId = productInfo?.getAttribute('data-product-id');
    }
    
    if (!productId) {
      console.error('[SR] Product ID not found');
      return;
    }
    
    console.log('[SR] Found productId:', productId);
    
    const fetchUrl = `/recommendations/products.json?product_id=${productId}&limit=4`;
    console.log('[SR] Fetching from:', fetchUrl);
    
    fetch(fetchUrl)
      .then(response => {
        console.log('[SR] Response status:', response.status);
        if (!response.ok) {
          throw new Error(`Recommendations endpoint returned status ${response.status}`);
        }
        return response.text();
      })
      .then(html => {
        console.log('[SR] Response received, length:', html?.length);
        
        if (!html || !html.trim()) {
          console.log('[SR] Response is empty');
          return;
        }
        
        try {
          const data = JSON.parse(html);
          console.log('[SR] Parsed JSON, products count:', data.products?.length);
          
          if (data.products && data.products.length > 0) {
            console.log('[SR] Rendering products');
            let productsHtml = '<div class="sidebar-recommendations-grid">';
            
            data.products.forEach(product => {
              const price = (product.price / 100).toFixed(2);
              const firstImage = product.featured_image;
              const secondImage = product.images && product.images.length > 1 ? product.images[1] : null;
              
              productsHtml += `
                <a href="${product.url}" class="sidebar-recommendation-card">
                  ${firstImage ? `
                    <div class="sidebar-recommendation-image">
                      <img src="${firstImage}" alt="${product.title}" class="primary-image">
                      ${secondImage ? `<img src="${secondImage}" alt="${product.title}" class="secondary-image">` : ''}
                    </div>
                  ` : ''}
                  <div class="sidebar-recommendation-info">
                    <h3 class="sidebar-recommendation-title">${product.title}</h3>
                    <p class="sidebar-recommendation-price">$${price} AUD</p>
                  </div>
                </a>
              `;
            });
            
            productsHtml += '</div>';
            placeholder.innerHTML = productsHtml;
            console.log('[SR] Products rendered successfully');
          }
        } catch (e) {
          console.log('[SR] JSON parse failed, treating as HTML');
          placeholder.innerHTML = html;
        }
      })
      .catch(error => {
        console.error('[SR] Fetch error:', error.message);
      });
  }
  
  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadSidebarRecommendations);
  } else {
    loadSidebarRecommendations();
  }
})();

